(function () {
  'use strict';
  if (window.__MYX_SHAPE_TRANSITION__) return;
  window.__MYX_SHAPE_TRANSITION__ = true;
  var active = {}, replaying = false, raf = 0;
  var colorTimer = 0, pendingColor = null;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var sizeSelector = '[data-category-id="Zs0mISKbbkrsanNymAIa6Zqf"], [data-category-id="CQ5DSHGSBYKcjbeq1b8rf7MU"]';
  // Shape changes use the approved fade. Size changes stay immediate; the viewer
  // fits their camera in the same layout commit, before the new geometry paints.
  var finishSelector = '[data-category-id="HLDWufZPnynTp9Z5O_n85-_k"] .cpb-option';
  var frameSelector = '.cpb-option[data-maytrix-shape]';
  var centerSelector = '[data-category-id="rGBsXKwwThNiSwykhXb9lpED"] .cpb-option, [data-myx-star-option]';
  var sidesSelector = '[data-category-id="-5rVa2YKJ10MFUHYFmKoRBJi"] .cpb-option, [data-myx-bar-pattern]';
  var colorSelector = '[data-category-id="ewsqpkHYBWFEbxeuQx2MyANc"] .cpb-option, [data-category-id="PBO5FoiL7WyPoltf_adurqLd"] .cpb-option, [data-myx-star-color], .cpb-option[aria-label^="Color option "]';
  var paletteSelector = '[data-category-id="tX9plGZdKZe03MX-EEvGihNC"] .cpb-option, [data-category-id="WiiTVkyNoqTYLTdu3prfwrKO"] .cpb-option';
  function model() { return window.MaytrixModelMotion; }
  function canvas() { return document.querySelector('#viewer-3d-root canvas'); }
  function inBuilder() { return document.body.classList.contains('myx-builder-focus') && !document.body.matches('.myx-review-open,.myx-review-pending'); }
  function selected(e) { return e && (e.getAttribute('aria-pressed') === 'true' || e.getAttribute('aria-checked') === 'true'); }
  function locate(s) {
    if (s.option && s.option.isConnected) return s.option;
    return s.selector ? document.querySelector('#product-builder ' + s.selector) : null;
  }
  function replay(s) {
    if (s.applied) return;
    s.applied = true;
    var e = locate(s);
    if (!e || selected(e)) return;
    replaying = true;
    try { e.click(); } finally { replaying = false; }
  }
  function value(s, v) {
    var m = model(), c = canvas();
    s.value = v;
    if (s.kind === 'frame') {
      if (c) { c.style.setProperty('opacity', String(v), 'important'); c.dataset.myxShapeTransition = s.phase; }
    } else {
      (s.kind === 'both' ? ['center','sides'] : [s.kind]).forEach(function (kind) {
        m[kind].progress.value = v;
        // Opacity-only changes use the same stagger as the independent bars.
        m[kind].depth.value = 1;
      });
    }
    if (c) c.setAttribute('data-myx-' + s.kind + '-motion', s.phase);
  }
  function finish(kind, commit) {
    var s = active[kind];
    if (!s) return;
    if (commit) replay(s);
    value(s, 1);
    var c = canvas();
    if (c) {
      c.removeAttribute('data-myx-' + kind + '-motion');
      if (kind === 'frame') { c.style.removeProperty('opacity'); c.removeAttribute('data-myx-shape-transition'); }
    }
    delete active[kind];
  }
  function finishAll(commit) {
    clearTimeout(colorTimer); colorTimer = 0; pendingColor = null;
    if (model() && model().finishColors) model().finishColors();
    if (model() && model().finishReplacements) model().finishReplacements();
    Object.keys(active).forEach(function (kind) { finish(kind, commit); });
    if (model()) model().watch = false;
  }
  function applyColor(option, kind, replayClick) {
    if (!option || !option.isConnected || selected(option)) return;
    finishAll(true);
    model().armColor(kind);
    if (replayClick) {
      replaying = true;
      try { option.click(); } finally { replaying = false; }
    }
  }
  function drainColor() {
    colorTimer = 0;
    if (!pendingColor || !inBuilder()) { pendingColor = null; return; }
    var wait = model().colorUntil - performance.now();
    if (wait > 0) { colorTimer = setTimeout(drainColor, wait + 20); return; }
    var next = pendingColor; pendingColor = null;
    applyColor(locate(next), next.kind, true);
  }
  function schedule() { if (!raf) raf = requestAnimationFrame(tick); }
  function tick(now) {
    raf = 0;
    var m = model();
    if (!m || document.hidden) { finishAll(true); return; }
    Object.keys(active).forEach(function (kind) {
      var s = active[kind];
      if (!s) return;
      if (!inBuilder()) { finish(kind, true); return; }
      var elapsed = now - s.at;
      if (s.phase === 'out') {
        if (s.uiEvent && elapsed >= s.out - 160) {
          document.dispatchEvent(new CustomEvent(s.uiEvent)); s.uiEvent = '';
        }
        var t = Math.min(1, elapsed / s.out);
        value(s, s.from * (1 - (kind === 'frame' ? t * t * (3 - 2 * t) : t)));
        if (t < 1) return;
        value(s, 0);
        s.before = m.signature; s.frame = m.frame;
        replay(s); s.phase = 'wait'; s.at = now;
      } else if (s.phase === 'wait') {
        value(s, 0);
        var changed = !s.option || m.signature !== s.before;
        var ready = changed && m.frame - s.frame >= 3 && now - m.changedAt >= 180 && elapsed >= 200 && m.textures === 0;
        if (!ready && elapsed < 2600) return;
        s.phase = 'in'; s.at = now;
      } else {
        var p = Math.min(1, elapsed / s.in);
        value(s, p);
        if (p === 1) finish(kind, false);
      }
    });
    m.watch = Object.keys(active).length > 0;
    if (m.watch) schedule();
  }
  function start(kind, option, committed) {
    var m = model(), c = canvas();
    if (!m || !c) return false;
    if (option && option.matches(centerSelector)) document.dispatchEvent(new CustomEvent('maytrix:center-choice-transition'));
    if (kind === 'both') { finish('center', true); finish('sides', true); }
    else if (kind !== 'frame') finish('both', true);
    var prior = active[kind];
    var from = prior ? prior.value : kind === 'frame' ? parseFloat(getComputedStyle(c).opacity) : kind === 'both' ? Math.min(m.center.progress.value, m.sides.progress.value) : m[kind].progress.value;
    if (prior) delete active[kind];
    var selector = option && (option.dataset.optionId ? '[data-option-id="' + option.dataset.optionId + '"]' : option.hasAttribute('data-myx-star-option') ? '[data-myx-star-option]' : option.dataset.myxBarPattern ? '[data-myx-bar-pattern="' + option.dataset.myxBarPattern + '"]' : option.dataset.myxStarColor ? '[data-myx-star-color="' + option.dataset.myxStarColor + '"]' : null);
    var s = active[kind] = {kind: kind, option: option, selector: selector, applied: !!committed, from: Number.isFinite(from) ? from : 1, value: 1, phase: 'out', at: performance.now(), out: kind === 'frame' ? (reduced.matches ? 170 : 180) : 1200, in: kind === 'frame' ? (reduced.matches ? 360 : 440) : 1600};
    if (option && option.matches('[data-category-id="-5rVa2YKJ10MFUHYFmKoRBJi"] .cpb-option')) s.uiEvent = 'maytrix:sides-choice-transition';
    m.watch = true; value(s, s.from); schedule(); return true;
  }
  window.addEventListener('click', function (event) {
    if (replaying || !event.isTrusted || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var target = event.target;
    if (!target.closest) return;
    var action = target.closest('button,a,[role="button"]');
    if (action && /^(?:edit my design|finish my design)$/i.test(action.textContent.trim())) { finishAll(true); return; }
    if (target.closest('.cpb-example-button,.myx-pattern-example')) return;
    if (!inBuilder() || !target.closest('#product-builder')) {
      if (action) { finishAll(true); }
      return;
    }
    var finishOption = target.closest(finishSelector);
    if (finishOption && model()?.prepareReplacement) {
      if (!selected(finishOption)) { finishAll(true); model().prepareReplacement('finish'); }
      return;
    }
    var colorOption = target.closest(colorSelector + ', ' + paletteSelector);
    if (colorOption && model() && model().armColor) {
      var colorPanel = colorOption.closest('[data-myx-focus-section]');
      var colorKind = colorPanel && colorPanel.dataset.myxFocusSection === 'center' ? 'center' : 'sides';
      if (selected(colorOption)) { clearTimeout(colorTimer); pendingColor = null; return; }
      if (model().colorUntil > performance.now()) {
        pendingColor = {option:colorOption, kind:colorKind, selector:colorOption.dataset.optionId ? '[data-option-id="'+colorOption.dataset.optionId+'"]' : colorOption.dataset.myxStarColor ? '[data-myx-star-color="'+colorOption.dataset.myxStarColor+'"]' : null};
        if (!colorTimer) colorTimer = setTimeout(drainColor, model().colorUntil - performance.now() + 20);
        event.preventDefault(); event.stopImmediatePropagation();
      } else applyColor(colorOption, colorKind, false);
      return;
    }
    var kind = 'frame', option = target.closest(frameSelector);
    if (!option) { kind = 'center'; option = target.closest(centerSelector); }
    if (!option) { kind = 'sides'; option = target.closest(sidesSelector); }
    if (!option) {
      if (action && !target.closest('input')) finishAll(true);
      return;
    }
    if (selected(option) && !active[kind]) return;
    if (kind !== 'frame' && model()?.prepareReplacement) {
      finishAll(true);
      if (kind === 'center') document.dispatchEvent(new CustomEvent('maytrix:center-choice-transition'));
      if (kind === 'sides' && option.matches('[data-category-id="-5rVa2YKJ10MFUHYFmKoRBJi"] .cpb-option')) document.dispatchEvent(new CustomEvent('maytrix:sides-choice-transition'));
      model().prepareReplacement(kind);
      return;
    }
    if (kind === 'frame' && model()?.finishReplacements) model().finishReplacements();
    if (start(kind, option, false)) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  window.addEventListener('pointerdown', function (event) {
    if (event.target.closest && event.target.closest('#viewer-3d-root')) { finishAll(true); }
  }, true);
  window.addEventListener('maytrix:preview-face-forward', function () { finishAll(true); });
  window.addEventListener('pagehide', function () { finishAll(false); });
  document.addEventListener('visibilitychange', function () { if (document.hidden) { finishAll(true); } });
  new MutationObserver(function () {
    if (!inBuilder()) finishAll(true);
  }).observe(document.body, {attributes:true, attributeFilter:['class']});

  var hoverMode = '';
  var hoverStyle = document.createElement('style');
  hoverStyle.textContent = 'body[data-myx-hover-label="size"] [role="tooltip"],body[data-myx-hover-label="size"] .Polaris-Tooltip{display:none!important}' +
    'body[data-myx-hover-label="rgb"] .Polaris-Tooltip__Label{font-size:0!important}' +
    'body[data-myx-hover-label="rgb"] .Polaris-Tooltip__Label>*{display:none!important}' +
    'body[data-myx-hover-label="rgb"] .Polaris-Tooltip__Label::after{content:"RGB"!important;font-size:13px!important;line-height:1.4!important}';
  document.head.appendChild(hoverStyle);
  function hover(event) {
    var target = event.target.closest && event.target.closest('#product-builder .cpb-option,#product-builder .option');
    var next = target && target.closest(sizeSelector) ? 'size' : target && (/^RGB$/i.test(target.getAttribute('data-myx-option-caption') || target.getAttribute('data-myx-choice-label') || '') || /^Color option RGB$/i.test(target.getAttribute('aria-label') || '') || /^RGB$/i.test((target.querySelector('.cpb-option-label') || target).textContent.trim())) ? 'rgb' : '';
    if (next !== hoverMode) { hoverMode = next; if (next) document.body.dataset.myxHoverLabel = next; else document.body.removeAttribute('data-myx-hover-label'); }
    if (target && next) target.querySelectorAll('[title]').forEach(function (e) { if (e.title !== 'Most popular') { if (next === 'rgb') e.title = 'RGB'; else e.removeAttribute('title'); } });
  }
  document.addEventListener('pointerover', hover, true);
  document.addEventListener('focusin', hover, true);
})();
